import React from 'react';
import classnames from 'classnames';

import CookieNotice from '../CookieNotice';
import { useApplicationState } from '../../contexts/application';
import { useNavigationState } from '../../contexts/navigation';

const BaseLayout = ({ children }) => {
  const { showCookieNotice } = useApplicationState();
  const { isOpen } = useNavigationState();

  return (
    <div
      className={classnames({
        'h-screen lg:h-auto lg:overflow-visible': isOpen,
      })}
    >
      {children}

      {showCookieNotice && <CookieNotice />}
    </div>
  );
};

export const getLayout = (page) => (
  <BaseLayout {...page.props}>{page}</BaseLayout>
);

export default BaseLayout;
